module.exports = __webpack_public_path__ + "assets/ProgramaAcreditacao.b4aa4882bc0108f156a97a3b86102b90.png";


/*****************
 ** WEBPACK FOOTER
 ** ./public/img/legenda/ProgramaAcreditacao.png
 ** module id = 476
 ** module chunks = 0
 **/